<template>
    <modal :show.sync=show modalClasses="large-sized-modal" headerClasses="pb-0" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500 text-center">Total Commitment Summary</h3>
        <div class="table-simple-modal">
            <b-table-simple responsive bordered>
                <b-thead>
                    <b-tr>
                        <b-th class="w-100">Type</b-th>
                        <b-th>Before (RM)</b-th>
                        <b-th>After (RM)</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
										<b-tr class="bg-grey">
											<b-th>Net Income</b-th>
											<b-th>{{ _gHlp.getValue(detailInflow,'net_income.amount_before',0) | moneyFormatter }}</b-th>
											<b-th>{{ _gHlp.getValue(detailInflow,'net_income.amount_after',0) | moneyFormatter }}</b-th>
										</b-tr>
                    <b-tr class="bg-grey">
											<b-th>Variable Expenses</b-th>
											<b-th>{{ _gHlp.getValue(sumVarExpenses,'amount_before',0) | moneyFormatter }}</b-th>
											<b-th>{{ _gHlp.getValue(sumVarExpenses,'amount_after',0) | moneyFormatter }}</b-th>
										</b-tr>
                    <b-tr class="bg-grey">
											<b-th>Final Commitment</b-th>
											<b-th>{{ _gHlp.getValue(sumCommitment,'amount_before',0) | moneyFormatter }}</b-th>
											<b-th>{{ _gHlp.getValue(sumCommitment,'amount_after',0) | moneyFormatter }}</b-th>
										</b-tr>
                </b-tbody>
                <b-tfoot>
                    <b-tr class="font-weight-600">
                        <b-td>Net Income (Before / After)</b-td>
                        <b-td :class="_gHlp.getNumberColorClass(_gHlp.getValue(sumTotal,'amount_before',0))">{{ _gHlp.getValue(sumTotal,'amount_before',0) | moneyFormatter }}</b-td>
                        <b-td :class="_gHlp.getNumberColorClass(_gHlp.getValue(sumTotal,'amount_after',0))">{{ _gHlp.getValue(sumTotal,'amount_after',0) | moneyFormatter }}</b-td>
                    </b-tr>
                </b-tfoot>
            </b-table-simple>
        </div>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
export default {
    props:{
        show_commitment_summary: Boolean,
        detailInflow: null,
        detailVarExpenses: Array,
        allCommitment: Array,
    },
    components: {
        Modal,
    },
    computed: {
        show: {
            get() {
                return this.show_commitment_summary;
            },
            set(newVal) {
                this.$emit('update:show_commitment_summary', newVal);
            },
        },
				sumCommitment(){
					let before = 0;
					let after = 0;
					if(!_gHlp.isEmpty(this.allCommitment)){
						for (const item of this.allCommitment) {
							if(item.pcom_is_include != 1) continue;

							if (item.pcom_type == 'CCRIS') {
								before += parseFloat(item.pcom_current_installment);
							} 
							// else {
							// 	// return (!_gHlp.isEmpty(item.pcom_product_detail)) ? item.pcom_product_detail.pcp_loan_amount : 0;
							// 	return 0;
							// }
							after += 	parseFloat(item.pcom_final_installment);
						}
					}

					return {
						amount_before:before,
						amount_after:after
					}
				},
				sumVarExpenses(){
					return {
						amount_before: _.sumBy(this.detailVarExpenses,(o)=>{return o.amount_before}),
						amount_after: _.sumBy(this.detailVarExpenses,(o)=>{return o.amount_after})
					}
				},
				sumTotal(){
					return {
						amount_before: parseFloat(_gHlp.getValue(this.detailInflow,'net_income.amount_before',0)) - ( this.sumVarExpenses.amount_before + this.sumCommitment.amount_before),
						amount_after:  parseFloat(_gHlp.getValue(this.detailInflow,'net_income.amount_after',0)) - ( this.sumVarExpenses.amount_after + this.sumCommitment.amount_after)
					}
				},


    },
    data() {
        return {}
    }
}
</script>